import { CiMail } from "react-icons/ci";
import { IoLocationOutline } from "react-icons/io5";
import { LuPhoneCall } from "react-icons/lu";

export default function SectionTwo()
{
    return(
        <section className="py-5 md:py-8 px-4 md:px-8 xl:px-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 xl:gap-10 w-full h-full text-[#5E5151]">
                <div className="flex flex-col items-center space-y-2 md:space-y-4 px-5 md:p-0">
                    <p className="text-base md:text-lg xl:text-xl font-medium text-[#6e2627]">Call us</p>
                    <div className="flex flex-col justify-center items-center bg-[#dfa7a733] rounded-md p-2  w-full h-32 md:h-40 xl:h-44">
                        <LuPhoneCall className="text-lg md:text-xl xl:text-2xl"/>
                        <p className="text-sm md:text-base xl:text-lg ">+91-234-456-5678</p>
                    </div>
                </div>

                <div className="flex flex-col items-center space-y-2 md:space-y-4 px-5 md:p-0">
                    <p className="text-base md:text-lg xl:text-xl font-medium text-[#6e2627]">Mail us</p>
                    <div className="flex flex-col justify-center items-center bg-[#dfa7a733] rounded-md p-2  w-full  h-32 md:h-40 xl:h-44">
                        <CiMail className="text-lg md:text-xl xl:text-2xl"/>
                        <p className="text-sm md:text-base xl:text-lg ">asialinkscomputers@gmail.com</p>
                    </div>
                </div>

                <div className="flex flex-col items-center space-y-2 md:space-y-4 px-5 md:p-0">
                    <p className="text-base md:text-lg xl:text-xl font-medium text-[#6e2627]">Visit us </p>
                    <div className="flex flex-col justify-center items-center bg-[#dfa7a733] rounded-md p-2 md:p-4 w-full h-32 md:h-40 xl:h-44">
                        <IoLocationOutline className="text-lg md:text-xl xl:text-2xl"/>
                        <p className="text-sm md:text-base xl:text-lg ">Shop No.-11, 1577,</p>
                        <p className="text-sm md:text-base xl:text-lg ">BhagyaNagari Society,</p>
                        <p className="text-sm md:text-base xl:text-lg ">Tilak Road, Sadashiv Peth,</p>
                        <p className="text-sm md:text-base xl:text-lg ">Pune - 411030</p>
                    </div>
                </div>
            </div>
        </section>
    );
}